import { Button, ButtonProps, CircularProgress, Grid2 as Grid, useTheme } from "@mui/material";
import React from "react";

interface Props extends ButtonProps {
  loading: boolean;
  loadingPosition?: "start" | "end" | "center";
}

export function LoadingButton(props: Props) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  return <Button {...computeProps(props, isDarkMode)} />;
}

function computeProps(props: Props, isDarkMode: boolean) {
  let { loading, loadingPosition = "center", startIcon, endIcon, children, ...restProps } = props;
  const isContained = props.variant === "contained";
  const loadingColor = isContained ? { color: isDarkMode ? "common.black" : "common.white" } : undefined;
  const loadingIcon = (
    <Grid container justifyContent="center" alignItems="center" width="20px" height="20px">
      <CircularProgress size={16} thickness={4} sx={loadingColor} />
    </Grid>
  );

  if (loadingPosition === "center") {
    children = loading ? loadingIcon : children;
  } else if (loadingPosition === "start") {
    startIcon = loading ? loadingIcon : startIcon;
  } else {
    endIcon = loading ? loadingIcon : endIcon;
  }

  return {
    ...restProps,
    startIcon,
    endIcon,
    children,
  };
}
